import { useState } from "react";
import { confirmarRestablecerClave, solicitarRestablecerClave } from "../api/apiConfig";

const RestablecerClave = ({ onBackToLogin }) => {
  const [step, setStep] = useState("email");
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [ok, setOk] = useState(false);

  const handleRequestCode = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    setOk(false);
    try {
      const result = await solicitarRestablecerClave(email.trim());
      if (result.success) {
        setOk(true);
        setMessage(result.message || "Enviamos un código de verificación a tu correo");
        setStep("codigo");
      } else {
        setMessage(result.message || "No se pudo enviar el código");
      }
    } catch (error) {
      setMessage(error.message || "Error de conexión");
    } finally {
      setLoading(false);
    }
  };

  const handleConfirm = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    setOk(false);
    try {
      const result = await confirmarRestablecerClave({
        email: email.trim(),
        code: code.trim(),
        password,
      });
      if (result.success) {
        setOk(true);
        setMessage(result.message || "Contraseña restablecida");
        setTimeout(() => onBackToLogin(), 1800);
      } else {
        setMessage(result.message || "No se pudo restablecer la contraseña");
      }
    } catch (error) {
      setMessage(error.message || "Error de conexión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="left-side-register">
        <div className="logo-container" />
        <div className="bottom-text">
          <h1>Restablecer<br />contraseña</h1>
          <p>Codigo de verificacion de Cognito</p>
        </div>
      </div>

      <div className="right-side">
        <div className="login-form-container">
          <div className="login-header">
            <div className="mgc-title">
              <img src="/img/logo.png" alt="Logo" className="logo-img" />
              <span className="mgc-text"><strong>MGC</strong> Restablecer clave</span>
            </div>
            <p className="login-subtitle">
              {step === "email"
                ? "Te enviaremos un codigo a tu correo"
                : "Ingresa el codigo y tu nueva contraseña"}
            </p>
          </div>

          {step === "email" ? (
            <form onSubmit={handleRequestCode}>
              <div className="input-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Correo electronico"
                  className="login-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={loading}
                />
              </div>
              {message && (
                <div className={`message ${ok ? "success" : "error"}`}>{message}</div>
              )}
              <button type="submit" className="login-button" disabled={loading}>
                {loading ? "Enviando codigo..." : "Enviar codigo"}
              </button>
            </form>
          ) : (
            <form onSubmit={handleConfirm}>
              <div className="input-group">
                <input
                  type="text"
                  name="code"
                  placeholder="Codigo de Cognito"
                  className="login-input"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  required
                  disabled={loading}
                />
              </div>
              <div className="input-group">
                <input
                  type="password"
                  name="password"
                  placeholder="Nueva contraseña"
                  className="login-input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  disabled={loading}
                />
              </div>
              {message && (
                <div className={`message ${ok ? "success" : "error"}`}>{message}</div>
              )}
              <button type="submit" className="login-button" disabled={loading}>
                {loading ? "Restableciendo..." : "Restablecer contraseña"}
              </button>
              <div className="footer-text">
                <button
                  type="button"
                  className="link-button"
                  disabled={loading}
                  onClick={handleRequestCode}
                >
                  Pedir otro código
                </button>
              </div>
            </form>
          )}

          <div className="footer-text">
            <button onClick={onBackToLogin} className="link-button" type="button">
              Volver al inicio de sesion
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RestablecerClave;
